import IterableDataProcessor from "../../entities/IterableDataProcessor.js";
import ResultFormatterBase from "../ResultFormatterBase.js";

class PropertyAssuranceFormatter extends ResultFormatterBase {
    constructor(dataParameterPath, predicate, defaultValue, customDataProcessor) {
        if (!(dataParameterPath instanceof Array)) {
            throw new TypeError('dataParameterPath must be an array');
        }

        if (typeof(predicate) !== 'function') {
            throw new TypeError('predicate must be an function taking extracted value as an input');
        }

        super();

        if (typeof(customDataProcessor) !== 'undefined' && !(customDataProcessor instanceof IterableDataProcessor)) {
            throw new TypeError('customDataProcessor when passed, must be an instance inheriting from IterableDataProcessor class');
        }

        this.dataParameterPath = dataParameterPath;
        this.predicate = predicate;
        this.defaultValue = defaultValue;
        this.dataProcessor = customDataProcessor || new IterableDataProcessor();
    }

    format(result) {
        if (!result) {
            return result;
        }

        const extractedValue = this.dataProcessor.getObjectContent(result, this.dataParameterPath);

        if (this.predicate(extractedValue)) {
            return result;
        }

        this.dataProcessor.setObjectContent(result, this.dataParameterPath, this.defaultValue);

        return result;
    }
}

export default PropertyAssuranceFormatter;